import { render, staticRenderFns } from "./AppStart.vue?vue&type=template&id=7207f4e4&"
import script from "./AppStart.vue?vue&type=script&lang=js&"
export * from "./AppStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports